import React from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import 'jquery-slimscroll/jquery.slimscroll.min';

import {toggleCollapsedNav, removeAlert} from 'actions/index';

import Header from "components/Header/index";
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';

import {UncontrolledAlert} from 'reactstrap';
import {Done, Warning, Error, Info} from 'material-ui-icons';

import {LinearProgress} from 'material-ui/Progress';

import Tour from "../components/Tour/index";

import {COLLAPSED_DRAWER, FIXED_DRAWER} from 'constants/ActionTypes';

import Login from './used/Login';
import PasswordResetRequest from './used/PasswordResetRequest';
import PasswordResetForm from './used/PasswordResetForm';

import Aircrafts from './used/aircrafts';
import Locations from './used/locations';
import Offers from './used/offers';
import Flights from './used/flights';
import Calendar from './used/calendar';
import Settings from './used/settings';
import Giftcards from './used/giftcards';
import Requests from './used/requests';
import Transfers from './used/transfers';
import PromoCodes from './used/promo-codes';

import Config from '../config';

import axios from 'axios';
import moment from 'moment-timezone';
import { loadSettings } from "../utils/client";

moment.locale(Config.DATETIME_LOCALE);

import { getLanguage, setLanguage, tsl } from './tsl';

axios.defaults.baseURL = Config.API_ROOT;
/*
axios.defaults.baseURL = 'http://localhost/my-air-seat_be/public/';
axios.defaults.headers.common['Authorization'] = "Bearer 5aff6c71990b1";
// */

if (Config.AUTH.REMEMBER_ME && localStorage && localStorage.getItem('access_token')) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('access_token');
}

class App extends React.Component {
    styles = {
        floatingAlertsContainer: {
            position: 'fixed',
            width: "100%",
            padding: 10,
            textAlign: 'center',
            bottom: 0,
            zIndex: 9999
        }
    }

    state = {
        remembered: !!axios.defaults.headers.common['Authorization'],
        initialized: false,
        alerts: [],
        alertCounter: 0,
        alertTimeout: 5, // seconds
        requestsInProgress: 0,
    };

    constructor(props) {
        super(props);

        axios.interceptors.request.use(
            (config) => {
                this.startedRequest();

                /* === not sending language param in each request === 
                 (backend is determining language of logged user automatically)

                // add _lang param to request if it's not already defined
                if (!config.params || !config.params['_lang']) {
                    config.params = { ...config.params, _lang: getLanguage() };
                }
                //*/

                return config;
            },
            (error) => {
                this.finishedRequest();
            }
        );

        axios.interceptors.response.use(
            (response) => {
                this.finishedRequest();

                return response;
            },
            (error) => {
                this.finishedRequest();

                if (error.response) {
                    switch (error.response.status) {
                        case 401: // unauthorized
                            this.addAlert(tsl('error.401'), 'warning');
                            break;

                        case 404: // Not found
                            this.addAlert(tsl('error.404'), 'error');
                            break;

                        case 422: // Validation errors
                            if (error.response.data) {
                              if (error.response.data.errors && Object.values(error.response.data.errors).length > 0) {
                                Object.values(error.response.data.errors).map(e => e.map(ee => this.addAlert(ee, 'error')));
                              } else if (error.response.data.message) {
                                this.addAlert(error.response.data.message, 'error');
                              }
                            }
                            break;

                        case 500: // internal server error
                            this.addAlert(tsl('error.500'), 'error');
                            break;
                    }
                } else {
                    this.addAlert(tsl('error.connection'), 'warning');
                }
                return Promise.reject(error);
            }
        );
        
        //axios.defaults.onUploadProgress = progressEvent => console.log('upload',progressEvent.loaded/progressEvent.total);
        //axios.defaults.onDownloadProgress = progressEvent => console.log('download',progressEvent.loaded/progressEvent.total);
        
    }

    componentDidMount() {
        if (this.state.remembered) {
            this.processLogin({
              data: {
                  token: localStorage.getItem('access_token')
              }
            });
        }
    }

    startedRequest = () => {
        //console.log('started request','current',this.state.requestsInProgress+1);
        this.setState({
            requestsInProgress: this.state.requestsInProgress+1,
        });
    }

    finishedRequest = () => {
        //console.log('finished request','current',this.state.requestsInProgress-1);
        this.setState({
            requestsInProgress: this.state.requestsInProgress-1,
        });
    }

    onToggleCollapsedNav = (e) => {
        const val = !this.props.navCollapsed;
        this.props.toggleCollapsedNav(val);
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.alerts.length > 0) {
            const alerts = nextProps.alerts.slice();
            alerts.map(a => {
                this.addAlert(a.text, a.type, a.timeout); // add alert to app state
                nextProps.removeAlert(a); // remove alert from global state
            });
        }
    }

    processLogin = (res) => {
        axios.defaults.headers.common['Authorization'] = "Bearer " + res.data.token;

        if (Config.AUTH.REMEMBER_ME && localStorage) {
            localStorage.setItem('access_token', res.data.token);
        }

        this.addAlert(tsl('success.login'), 'success', 2);

        this.setState({
            initialized: true
        });

        return axios.get('/auth/user/me')
        .then((res) => {
            // if there is user specific language, set language
            if (res.data.user.language_code) {
                setLanguage(res.data.user.language_code);
            }
            this.setState({
                initialized: {user: res.data.user}
            });

            loadSettings();
        });
    };

    onLogin = (email, pwd) => {
        //console.log('login processing');

        axios.post('/auth/login', {
            'email': email,
            'password': pwd
        })
        .then(this.processLogin)
        .catch((err) => {
            console.log(err);
            this.setState({
                initialized: false
            });
            //this.addAlert('Username or password is not correct!','error',5);
        })
    };

    onLogout = () => {
        this.setState({
            initialized: false           
        });

        if (localStorage && localStorage.getItem('access_token')) {
            localStorage.removeItem('access_token');
        }

        axios.get('/auth/logout');

        delete axios.defaults.headers.common['Authorization'];
    };

    renderContent = () => {
        const {match, clientSettings} = this.props;

        if (!clientSettings) {
            return null;
        }

        return (
            <Switch>
                <Route path={`${match.url}/aircrafts`} component={Aircrafts}/>
                <Route path={`${match.url}/locations`} component={Locations}/>
                <Route path={`${match.url}/offers`} component={Offers}/>
                <Route path={`${match.url}/transfers`} component={Transfers}/>
                <Route path={`${match.url}/flights`} component={Flights}/>
                <Route path={`${match.url}/calendar`} component={Calendar}/>
                <Route path={`${match.url}/settings`} component={Settings}/>
                <Route path={`${match.url}/giftcards`} component={Giftcards}/>
                <Route path={`${match.url}/requests`} component={Requests}/>
                <Route path={`${match.url}/promo-codes`} component={PromoCodes}/>
            </Switch>
        );
    };

    removeAlert = (id) => () => {
        const alerts = this.state.alerts;
        let newAlerts = []
        for (let i in alerts) {
            if (alerts[i].id != id) {
                newAlerts.push(alerts[i]);
            }
        }
        this.setState({
            alerts: newAlerts
        });
    }

    addAlert = (text, type = null, timeout = null) => {
        let alerts = this.state.alerts;
        const alertId = this.state.alertCounter;
        
        if (!type) type = 'info';
        if (!timeout) timeout = this.state.alertTimeout;

        alerts.push({
            type: type,
            text: text,
            id: alertId,
        });

        setTimeout(this.removeAlert(alertId), timeout*1000);
        
        this.setState({
            alerts: alerts,
            alertCounter: alertId+1
        });
    }

    renderAlerts = () => {
        let types = {
            'primary':     {icon: <Info />, bgClass: 'primary'},
            'secondary':   {icon: <Info />, bgClass: 'secondary'},
            'success':     {icon: <Done />, bgClass: 'success'},
            'error':        {icon: <Error />, bgClass: 'danger'},
            'warning':     {icon: <Warning />, bgClass: 'warning'},
            'info':        {icon: <Info />, bgClass: 'info'},
        };

        return (
            <div style={this.styles.floatingAlertsContainer}>
                {this.state.alerts.map((alert, index) => {
                    const type = (types[alert.type] != undefined) ? alert.type : 'info';
                    const typeStyle = types[type];
                    return (
                        <UncontrolledAlert key={index} className={"alert-addon-card bg-"+typeStyle.bgClass+" text-white shadow-lg"}>
                            <span className="icon-addon alert-addon">
                                {typeStyle.icon}
                            </span>

                            <span className="d-inline-block">{alert.text}</span>
                        </UncontrolledAlert>
                    );
                })}
            </div>
        );
    }

    renderRequestProgress = () => {
        return (
            <div style={{position: 'fixed', top: 0, zIndex: 9999, width: "100%"}}>
                {this.state.requestsInProgress > 0 ? <LinearProgress /> : null}
            </div>
        );
    }

    render() {
        const {match, drawerType} = this.props;

        const drawerStyle = drawerType.includes(FIXED_DRAWER) ? "fixed-drawer" : drawerType.includes(COLLAPSED_DRAWER) ? "collapsible-drawer" : "mini-drawer";

        return (this.state.initialized ?
            <div className={`app-container ${drawerStyle}`}>
                {/* <Tour/> */}
                {this.renderRequestProgress()}

                <Sidebar 
                    onToggleCollapsedNav={this.onToggleCollapsedNav.bind(this)}
                    onLogout={this.onLogout}
                    user={this.state.initialized.user ? this.state.initialized.user : {}}
                />

                <div className="app-main-container">
                    <Header drawerType={drawerType} onToggleCollapsedNav={this.onToggleCollapsedNav}/>
                    <main className="app-main-content-wrapper">
                        <div className="app-main-content" style={{padding: 20}}>
                            {this.renderContent()}
                        </div>
                    </main>
                    {/* <Footer/> */}
                </div>
                {this.renderAlerts()}
            </div>
        : 
            <div className="app-container">
                {this.renderRequestProgress()}
                <div className="app-main-container">
                    <Switch>
                        <Route exact path={`${match.url}/password-reset`} component={PasswordResetRequest}/>
                        <Route exact path={`${match.url}/password-reset/:token`} render={(props) => <PasswordResetForm {...props} processLogin={this.processLogin} />}/>

                        <Route render={(props) => <Login {...props} onLogin={this.onLogin} />} />
                    </Switch>
                </div>
                {this.renderAlerts()}
            </div>
        );
    }
}

const mapStateToProps = ({appAlerts, settings}) => {
    const {navCollapsed, drawerType, clientSettings} = settings;
    const { alerts } = appAlerts;
    return {
        navCollapsed, 
        drawerType,
        alerts,
        clientSettings
    }
};
export default withRouter(connect(mapStateToProps, {toggleCollapsedNav, removeAlert})(App));


// WEBPACK FOOTER //
// ./app/index.js